<template>
  <div class="container-collapsible">
    <div>
      <CollapseControllerSummary :showTimeSelection="false" :fullscreen="false" />
      <ButtonOutline
        v-if="
          filters &&
          'calendar' in filters.current &&
          filters.current.calendar &&
          (filters.current.calendar.from ||
            filters.current.calendar.to ||
            filters.current.calendar.quickSelect)
        "
        id="calendar-open-button"
        size="small"
        :button-text="buttonText"
        :style="'white-space:nowrap; overflow:hidden; text-overflow:ellipsis'"
        @onClicked="$emit('present-calendar')"
      />
    </div>
    <div>
      <AccordionText
        id="collapse-toggle-button"
        :active="!isCollapsed"
        :size="'small'"
        :accordionText="label"
        @onClicked="$emit('toggle-collapse')"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import CollapseControllerSummary from './CollapseControllerSummary.vue'
import { useI18n } from 'vue-i18n'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import { useButtonTextFormatter } from './composables'
import AccordionText from '@/design-system/atoms/AccordionText.vue'
import { LOCALES } from '@/utils/locales'
import { useCurrentFeatureFilters } from '@/composables/useFilters'

const { t, locale } = useI18n()

const filters = useCurrentFeatureFilters()
const { buttonText } = useButtonTextFormatter(LOCALES[locale.value])
type Props = {
  isCollapsed: boolean
  showCalendar: boolean
}
type Emits = {
  (e: 'toggle-collapse')
  (e: 'present-calendar')
}
defineProps<Props>()
defineEmits<Emits>()
const label = t('general__text__dashboard_change_filtering')
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.container-collapsible {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: variables.$padding-medium;
  margin-bottom: 16px;
  margin-top: 8px;
  align-items: flex-end;
}
#collapse-toggle-button {
  height: 32px;
  white-space: nowrap;
}
#calendar-open-button {
  margin-top: 8px;
}
.icon {
  transform: rotate(180deg);
}
.rotated {
  transform: rotate(0deg);
}
button {
  border: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: variables.$color-primary;
  gap: variables.$padding-medium;
  @include font-mixins.desktop-bold-label;
  height: variables.$button-small;
  span {
    white-space: nowrap;
  }
  &:hover {
    color: variables.$color-primary-dark;
  }
}
</style>
